<template lang="pug">
  BaseModal.ModalDisclaimerDisclosure(
    :value="value",
    v-bind="$attrs",
    v-on="$listeners",
    @close="$emit('cancel')"
  )
    template(#title) Site Disclosure
    .modal-disclosure-content
      p By using this Site, you are subject to our&nbsp;
        a.link-2(href="/company/terms" target="_blank") Terms of Use
        |  and our&nbsp;
        a.link-2(href="/company/privacy" target="_blank") Privacy Policy
        | . Please read these carefully before proceeding.
      p Our Site offers qualified investors the opportunity to invest in agricultural
        |  land. However, we do not make recommendations regarding the appropriateness
        |  of any particular opportunity for any particular investor.
        i  We are not investment advisers.
        |  Investors must make their own investment decisions, either alone or with
        |  their personal advisors.
      p All real estate, including agricultural land, can be risky and unpredictable.
        |  For example, many experienced, informed people lost money when the real
        |  estate market declined in 2007-8. Time has shown that the real estate market
        |  goes down without warning, sometimes resulting in significant losses.
        |  Some of the risks of investing in real estate include changing laws,
        |  including environmental laws; floods, fires, and other Acts of God, some of
        |  which can be uninsurable; changes in national or local economic conditions;
        |  changes in government policies, including changes in interest rates established
        |  by the Federal Reserve; and international crises. You should invest in real
        |  estate in general, and in the opportunities listed at the Site in particular,
        |  only if you can afford to lose your investment and are willing to live with
        |  the ups and downs of the real estate industry.
      p We may provide financial projections for some of the investment opportunities
        |  listed on the Site.
        i  All such financial projections are only estimates based on current conditions
          |  and current assumptions.
        |  The actual result of any investment is likely to be different than the original
        |  projection, often by a large amount. Neither we nor anyone else guarantees the
        |  results reflected in financial projections.
      p Neither the Securities and Exchange Commission nor any state agency has reviewed
        |  the investment opportunities listed on the Site.
      p Thank you for using the Site. If you have questions, please contact us at&nbsp;
        a.link-2(href="mailto:info@acretrader.com" target="_blank") info@acretrader.com
</template>

<script>
import BaseModal from 'Components/Base/BaseModal';

export default {
  name: 'ModalDisclaimerDisclosure',
  components: { BaseModal },
  props: {
    value: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
::v-deep .modal__header
  background-color: $secondary
.modal-disclosure-content
  width: 100%
  max-width: 1140px
  height: auto
  margin: 0 auto
</style>
